<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pv"></a><i>Contents</i></p>
<p class="contents"><a href="#/acknowledgments.htm">Acknowledgments</a></p>
<p class="contents"><a href="#/introduction_home_improvements.htm">Introduction: Home Improvements</a></p>
<p class="contents"><a href="#/1_how_to_read.htm"><span class="contentblock">1.</span>How to Read</a></p>
<p class="contents"><a href="#/2_reading_and_sociability.htm"><span class="contentblock">2.</span>Reading and Sociability</a></p>
<p class="contents"><a href="#/3_using_books.htm"><span class="contentblock">3.</span>Using Books</a></p>
<p class="contents"><a href="#/4_access_to_reading.htm"><span class="contentblock">4.</span>Access to Reading</a></p>
<p class="contents"><a href="#/5_verse_at_home.htm"><span class="contentblock">5.</span>Verse at Home</a></p>
<p class="contents"><a href="#/6_drama_and_recital.htm"><span class="contentblock">6.</span>Drama and Recital</a></p>
<p class="contents"><a href="#/7_fictional_worlds.htm"><span class="contentblock">7.</span>Fictional Worlds</a></p>
<p class="contents"><a href="#/8_piety_and_knowledge.htm"><span class="contentblock">8.</span>Piety and Knowledge</a></p>
<p class="contents"><a href="#/afterword.htm">Afterword</a></p>
<p class="contents"><a href="#/notes.htm">Notes</a></p>
<p class="contents"><a href="#/index.htm">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d38747be